module.exports = __webpack_public_path__ + "img/版块bg.7868aee3.png";